import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ThumbsDownIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.00206 12C6.6619 10.9795 4.0079 9.52514 1.99083 9.11282C1.45054 9.00238 1.00071 8.55482 1.00059 8.00336L1.0003 7.11238C0.999992 6.28154 0.999718 5.54547 1.00057 4.74807C1.00116 4.19629 1.45126 3.70835 1.96219 3.5C2.21214 3.39808 2.48656 3.27184 2.7858 3.13419C3.13266 2.97463 3.51303 2.74436 3.92734 2.49355C5.0388 1.8207 6.39448 1 8.00251 1H11.6706C12.1518 1 12.5648 1.34274 12.6535 1.81571C12.7285 2.02761 12.5714 2.25 12.3466 2.25H10.3731C10.166 2.25 9.99813 2.41789 9.99813 2.625C9.99813 2.83211 10.166 3 10.3731 3H12.6313C12.896 3 13.132 3.16679 13.2204 3.41635C13.3645 3.8231 13.0628 4.25 12.6313 4.25H11.3731C11.166 4.25 10.9981 4.41789 10.9981 4.625C10.9981 4.83211 11.166 5 11.3731 5H12.498C12.5266 5 12.9559 5.00575 13.3481 5.00786C13.681 5.00964 14.0545 5.31243 14.1137 5.63996C14.1712 5.95773 13.927 6.25 13.6041 6.25H12.3731C12.166 6.25 11.9981 6.41789 11.9981 6.625C11.9981 6.83211 12.166 7 12.3731 7H13.6242C14.1429 7 14.6053 7.32679 14.7785 7.81571C14.8939 8.43113 14.4218 9 13.7956 9H11.0025L10.9969 8.99998H10.0021C9.44978 8.99998 9.00207 9.4472 9.00207 9.99949V13C9.00207 14.2 8.50206 15 7.50206 15C6.92092 15 6.98145 14.3921 7.05562 13.6473C7.10907 13.1105 7.1696 12.5026 7.00206 12Z"
		/>
	</svg>
))
